import React from "react";
import { Wrap, SliderSlick, Details, Icons, FullData, User } from "./style";
import { useHousesContext } from "../../../context/Houses";
import { useQuery } from "react-query";
import { useAxios } from "../../../hooks/useAxios";
import img from "../../../assets/imgs/img.png";
import { useParams } from "react-router-dom";
export default function IndivialHouse() {
  const param = useParams();
  const [{ house }, dispatch] = useHousesContext();
  const imgData = [
    "https://images.unsplash.com/photo-1599809275671-b5942cabc7a2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    "https://media.istockphoto.com/photos/formal-livingroom-with-arched-windows-picture-id157483485?k=20&m=157483485&s=170667a&w=0&h=v4lYpFrXVUVEQWEXWxKTAsk0NyS8ZShfAB631iVKK3Q=",
    "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE4fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    "https://images.unsplash.com/photo-1560184897-ae75f418493e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDN8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    "https://images.unsplash.com/photo-1560185009-5bf9f2849488?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDR8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    "https://media.istockphoto.com/photos/luxury-living-picture-id155597482?k=20&m=155597482&s=170667a&w=0&h=MYy_dFzLcohzrvV1LWSLKjwThoQBQFDThJMnSCcxqiE=",
    "https://images.unsplash.com/photo-1416331108676-a22ccb276e35?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDN8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE3fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    "https://images.unsplash.com/photo-1606819422797-74627f4dac0b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE1fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
  ];

  const { request } = useAxios();

  console.log(house);
  useQuery(
    ["fetIndividualHouse"],
    () =>
      request({
        url: `/v1/houses/${param?.id}`,
      }),
    {
      onSuccess: (res) => {
        res?.data?.success &&
          dispatch({ type: "setHouse", payload: res?.data?.data });
      },
      onError: (err) => console.log(err),
    }
  );
  const settings = {
    customPaging: function (index) {
      return <img className="selected" alt="rasm" src={imgData[index]} />;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <Wrap>
      <Wrap.Slider>
        <Wrap.Icons>
          <Wrap.Icon>
            <Wrap.Galary />
          </Wrap.Icon>
          <Wrap.Icon mr="0 6px">
            <Wrap.Map />
          </Wrap.Icon>
          <Wrap.Icon>
            <Wrap.Location />
          </Wrap.Icon>
        </Wrap.Icons>
        <SliderSlick {...settings}>
          {imgData.map((item, index) => (
            <div key={index} className="slick-img-wrap">
              <img className="allImg" alt="rasm" src={item} />
            </div>
          ))}
        </SliderSlick>
      </Wrap.Slider>
      <Icons>
        <Details>
          <Details.Title>{house?.name}</Details.Title>
          <Details.Desc>
            {house?.address}, {house?.city} , {house?.country}
            <Details.Button>FEATERED</Details.Button>
            <Details.Button background="#CC5040">HOT OFFER</Details.Button>
            <Details.Button background="#0D263B">FOR SALE</Details.Button>
          </Details.Desc>
          <Details.House>
            <span>
              <Icons.Beds /> {house?.houseDetails?.beds || 0} Beds
            </span>
            <span>
              <Icons.Bath /> {house?.houseDetails?.bath || 0} Baths
            </span>
            <span>
              <Icons.Car /> {house?.houseDetails?.garage
                ? house?.houseDetails?.garage
                : "No Garage"} Garage
            </span>
            <span>
              <Icons.Ruler /> {house?.houseDetails?.area || 0} Sq ft
            </span>
            <span>
              <Icons.Calndar /> Year built: 2019
            </span>
          </Details.House>
        </Details>
        <Icons.Prices>
          <Icons.Wrap>
            <span>
              <Icons.Share /> Share
            </span>
            <span>
              <Icons.Heart /> Save
            </span>
          </Icons.Wrap>
          <Icons.Price>
            <span> ${house?.price}/mo</span> <h1>${house?.salePrice}/mo</h1>
          </Icons.Price>
          <Icons.Name>Est. Mortgage</Icons.Name>
        </Icons.Prices>
      </Icons>

      <FullData>
        <FullData.Description>
          <FullData.Title>Description</FullData.Title>
          <FullData.Info>{house?.description}</FullData.Info>
          <FullData.Title>Location</FullData.Title>
          <FullData.Location>
            <div>
              Address: <span> {house?.address || "Not Given"}</span>
            </div>
            <div>
              City: <span> {house?.city || "Not Given"}</span>
            </div>
            <div>
              Area:
              <span> {house?.houseDetails?.area || "Not Given"} St ft</span>
            </div>
            <div>
              State/County: <span> {house?.region || "Not Given"}</span>
            </div>
            <div>
              Zip: <span> {house?.zipCode || "Not Given"}</span>
            </div>
            <div>
              Country: <span> {house?.country || "Not Given"}</span>
            </div>
          </FullData.Location>
          <FullData.Title>Property Details</FullData.Title>
          <FullData.Location>
            <div>
              Property ID: <span>{house?.propertyId || "Not Given"} </span>
            </div>
            <div>
              Bedrooms:
              <span>{house?.houseDetails?.bedrooms || "Not Given"}</span>
            </div>
            <div>
              Property Type:{" "}
              <span> {house?.category?.name || "Not Given"}</span>
            </div>
            <div>
              Price: <span>{house?.price || "Not Given"}</span>
            </div>
            <div>
              Bathrooms:
              <span>{house?.houseDetails?.bath || "Not Given"}</span>
            </div>
            <div>
              Property Status: <span>{house?.statuss || "Not Given"}</span>
            </div>
            <div>
              Property Size:
              <span>{house?.houseDetails?.area || "Not Given"}</span>
            </div>
            <div>
              Garage: <span>{house?.houseDetails?.garage
                ? house?.houseDetails?.garage
                : "No Garage"}</span>
            </div>
            <div />
            <div>
              Year built: <span>{house?.yearbuilt || "Not Given"}</span>
            </div>
            <div>
              Garage Size: <span>{house?.garageSize || "Not Given"}</span>
            </div>
          </FullData.Location>
        </FullData.Description>
        <FullData.Contact>
          <User>
            <User.Wrap>
              <User.Img src={img} alt="img" />
              <User.Details>
                <User.Name>Name Surname</User.Name>
                <User.Tel>(123)456-7890</User.Tel>
                <User.View>View Listing </User.View>
              </User.Details>
            </User.Wrap>
            <User.Input placeholder="Name" />
            <User.Input placeholder="Phone" />
            <User.Input placeholder="Email" />
            <label htmlFor="msg">Message</label>
            <textarea name="msg" id="msg" cols="10" rows="8">
              Hello, I am interested in [New Apartment]
            </textarea>
            <User.Submit>
              <input id="submit" type="checkbox" />
              <label htmlFor="submit">
                By submitting this form I agree to Terms of Use
              </label>
            </User.Submit>
            <User.Button>CONTACT PROPERTY</User.Button>
            <User.Button top="10px" bg="#fff" color="#48C740" bcolor="#48C740">
              WHATSAPP
            </User.Button>
          </User>
        </FullData.Contact>
      </FullData>
    </Wrap>
  );
}
